import { HOST_LABEL } from "../../constants/label";

export function getLabelNameFromHost(host: string | undefined) {
  return typeof host !== "undefined"
    ? HOST_LABEL[host as keyof typeof HOST_LABEL]
    : undefined;
}
